import React from 'react';
import { useParams } from 'react-router-dom';
import { PageLayout } from '../account/layout/PageLayout';

import { GameIds } from '../account/my-games/MyGames.model';
import { ProvidePromotion } from '../account/promotion/PromotionContext';
import { useAuth } from '../authentication/AuthenticationContext';
import { Activation } from './Activation';
import { ActivationNotConnected } from './ActivationNotConnected';

export function ActivationPage(): JSX.Element {
  const { gameId }: { gameId: GameIds } = useParams();
  const { user } = useAuth();

  return (
    <>
      {!user && (
        <PageLayout hideMenu disableTransitions>
          <ActivationNotConnected gameId={gameId} />
        </PageLayout>
      )}
      {user && (
        <PageLayout hideMenu disableTransitions>
          <ProvidePromotion requiredGameId={gameId}>
            <Activation requiredGameId={gameId} />
          </ProvidePromotion>
        </PageLayout>
      )}
    </>
  );
}
